'use client'

import { serviceType } from '@/lib/service/server'
import { X } from 'lucide-react'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'

interface ArticleSaleNotificationProps {
  service: serviceType
}

const STORAGE_KEY = 'article-sale-notification-closed'

const ArticleSaleNotification = ({ service }: ArticleSaleNotificationProps) => {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const isClosed = localStorage.getItem(STORAGE_KEY)
    if (isClosed) {
      setIsVisible(false)
    }
  }, [])

  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setIsVisible(false)
    localStorage.setItem(STORAGE_KEY, new Date().toISOString())
  }

  if (!isVisible) return null

  return (
    <Link href="/sale">
      <div
        className="fixed right-4 z-50 shadow-lg rounded-lg w-[140px] h-[140px] flex flex-col justify-center items-center transition-all hover:opacity-90"
        style={{
          top: 'calc(100vh - 180px)',
          backgroundColor: service.main_color,
        }}
      >
        <button
          onClick={handleClose}
          className="absolute -top-2 -right-2 bg-gray-800 text-white rounded-full p-1 hover:bg-gray-700 transition-colors shadow-md"
          aria-label="閉じる"
        >
          <X size={16} />
        </button>
        <div className="flex flex-col items-center px-2 text-center">
          <p className="text-white font-bold text-sm mb-2">24時間限定</p>
          <p className="text-white font-bold text-sm mb-1">限定セール</p>
          <p className="text-white font-bold text-sm">実施中！</p>
        </div>
      </div>
    </Link>
  )
}

export default ArticleSaleNotification
